import { IRandomAccessDataSource } from "@colibrio/colibrio-reader-framework/colibrio-core-io-base";
import { AwsHttpRequest } from "./AwsHttpRequest";

export class AwsDataSourceOptions {
    headers?: { [key: string]: string; } | null = null;
    urlResolver!: Function;
}

export class AwsDataSource implements IRandomAccessDataSource { 
    constructor(private url: string, private size: number, private options: AwsDataSourceOptions) {
    
    }

    /**
     * Fetch a chunk of data from the data source between a start and end offset.
     * This method must not throw an exception in case of a non-recoverable error.
     *
     * @param startOffset - An index into the data source indicating the first byte to include in the result buffer
     * @param endOffset - An index into the data source indicating the first byte that will *not* be included in the result buffer. Must be larger than 'start', and less than or equal to the value returned by getSize().
     * @return Resolved with an ArrayBuffer containing the requested data. Rejected if it is not possible to fetch the requested data.
     */
    fetchChunk(startOffset: number, endOffset: number): Promise<ArrayBuffer> {
        return AwsHttpRequest.sendRangeRequest(this.url, startOffset, endOffset - 1).catch((err)=>{
            // Is it time to fetch a new signed url?
            if(err.status == 403){
                console.log("STATUS 403");
                return this.options.urlResolver(this.url).then((url: string)=>{
                    if (url){
                        this.url = url;
                        return this.fetchChunk(startOffset, endOffset);
                    }
                    return new Promise<ArrayBuffer>(()=>{});
                });
            }
        });
    }

    /**
     * Get the size of the data in bytes.
     */
    getSize(): number {
        return this.size;
    }

}



